module.exports = __webpack_public_path__ + "img/logo_oncogitiel_grey.a683399b.png";